import { Directive, HostListener } from '@angular/core'

@Directive({
	selector: '[mvPreventAlpha]',
})
export class PreventAlphaDirective {
	// eslint-disable-next-line @typescript-eslint/no-magic-numbers
	private readonly numericKeys: string[] = [...new Array(10)].map((_, i) => `${i}`)
	private readonly otherAllowedKeys: string[] = ['Delete', 'Tab', 'Backspace']
	private readonly preventableKeys: string[] = this.numericKeys.concat(this.otherAllowedKeys)

	constructor () { }

	@HostListener('keydown', ['$event'])
	preventAlpha (ev: KeyboardEvent): void | boolean {
		if (!this.preventableKeys.includes(ev.key)) {
			ev.preventDefault()

			return false
		}
	}

}
